
<div v-if="item">
    <v-row class="no-frame">
        <v-col class="no-frame">
            <div class="v-flex">
                <inb-message-types
                    v-model   = "messageType"
                    label     = "Meldungsart"
                    :readonly = "readonly"
                    @changed  = "onMessagetype"
                />
                <div v-if="forceMorph" class="pt-4">
                    <c-toolbar-button
                        icon="mdi-thumb-up-outline"
                        size="22"
                        color="primary"
                        tooltip="Meldungsart bestätigen"
                        @click="onForceMorph"
                    />
                </div>
            </div>
        </v-col>
    </v-row>
    <v-row class="no-frame">
        <v-col class="no-frame">
            <c-customer-select
                v-model     = "item.customer"
                :label      = "$t ('inb.detail.assessment.customer')"
                :lim-customer = "true"
                :additional = "item.customer"
                :rules      = "[requiredRule]"
                :readonly   = "readonly"
                :clearable  = "!readonly"
                @change     = "onCustomer"
            />
        </v-col>
    </v-row>
    <v-row class="no-frame" >
        <v-col class="no-frame">
            <v-alert
                v-if  = "!item.customer && !loading"
                color = "error"
                type  = "error"
                class = "pa-2 white--text mt-2"
            >
                Der Meldung sind noch keine Anlagen zugeordnet. Zur Auswahl der Anlagen muss zuerst der Kunde angegeben werden.
            </v-alert>

            <c-site-select-multiple
                v-if      = "item.customer"
                :customer = "item.customer"
                :sites    = "item.sites"
                :readonly = "readonly"
                :navigate = "false"
                ref       = "sitelist"
                @changed  = "onUnits"
                :key      = "refresh"
            />
        </v-col>
    </v-row>
</div>
